import { Ban } from "lucide-react";
import { PROPERTY_TYPES, AREA_UNITS } from "../../lib/categories";

const Label = ({ children, req }) => <label className="block text-sm font-semibold text-[var(--navy)] mb-1.5">{children}{req && <span className="text-[var(--sell)]"> *</span>}</label>;

function YesNo({ value, onChange, testId }) {
  return (
    <div className="grid grid-cols-2 gap-3">
      {[[true, "हो · Yes"], [false, "नाही · No"]].map(([v, l]) => (
        <button key={l} type="button" onClick={() => onChange(v)} className={`h-12 rounded-lg border-2 font-semibold transition-colors ${value === v ? (v ? "border-green-600 bg-green-50 text-green-800" : "border-[var(--sell)] bg-red-50 text-[var(--sell)]") : "border-slate-200 text-slate-600"}`} data-testid={`${testId}-${v ? "yes" : "no"}`}>{l}</button>
      ))}
    </div>
  );
}

export default function PropertyFields({ form, setForm }) {
  const set = (patch) => setForm({ ...form, ...patch });
  const needs712 = ["farmland", "plot"].includes(form.property_type);
  return (
    <div className="rounded-2xl border-2 border-green-600 bg-green-50/40 p-4 md:p-5 space-y-5" data-testid="property-fields">
      <p className="font-display font-bold text-lg text-green-800">प्रॉपर्टी माहिती · Property Details</p>
      <div>
        <Label req>प्रॉपर्टी प्रकार</Label>
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-2">
          {Object.entries(PROPERTY_TYPES).map(([k, { mr, icon: Icon }]) => (
            <button key={k} type="button" onClick={() => set({ property_type: k })} className={`h-14 rounded-lg border-2 text-sm font-semibold flex flex-col items-center justify-center gap-0.5 transition-colors ${form.property_type === k ? "border-green-600 bg-white text-green-800" : "border-slate-200 bg-white text-slate-600"}`} data-testid={`sell-ptype-${k}`}>
              <Icon className="w-4 h-4" /> {mr}
            </button>
          ))}
        </div>
      </div>
      <div>
        <Label req>एरिया किती · Area</Label>
        <div className="flex gap-2">
          <input className="field" type="number" min="0" step="any" required value={form.area} onChange={(e) => set({ area: e.target.value })} placeholder="उदा. 20" data-testid="sell-area-input" />
          <select className="field !w-36 shrink-0" required value={form.area_unit} onChange={(e) => set({ area_unit: e.target.value })} data-testid="sell-area-unit-select">
            <option value="">Unit</option>
            {Object.entries(AREA_UNITS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </select>
        </div>
      </div>
      {needs712 && (
        <div>
          <Label>7/12 उतारा आहे का?</Label>
          <YesNo value={form.has_712} onChange={(v) => set({ has_712: v })} testId="sell-712" />
        </div>
      )}
      <div>
        <Label req>तुम्ही डायरेक्ट मालक आहात का?</Label>
        <YesNo value={form.direct_owner} onChange={(v) => set({ direct_owner: v })} testId="sell-owner" />
        {form.direct_owner === false && (
          <p className="mt-2 rounded-lg bg-red-50 border border-red-200 px-3 py-2 text-sm font-semibold text-[var(--sell)] flex gap-2" data-testid="sell-broker-blocked">
            <Ban className="w-4 h-4 shrink-0 mt-0.5" /> माफ करा - दलाल / एजंटना जाहिरात टाकता येणार नाही. फक्त डायरेक्ट मालक.
          </p>
        )}
      </div>
      <p className="text-xs text-slate-600">गावाचे नाव खालील "ठिकाण" मध्ये नक्की लिहा (Property साठी आवश्यक).</p>
    </div>
  );
}
